<wl-busy *ngIf="_loadingState.busy" [show]="true"></wl-busy>
<div class="text-danger" *ngIf="!_loadingState.busy && !_loadingState.success && _loadingState.message?.length">
  {{ _loadingState.message }}
</div>
<div *ngIf="!_loadingState.busy && _loadingState.success && !_ceuTypes?.length">{{ 'config.ceu.no-credit-types' | translate }}</div>
<select
  *ngIf="!_loadingState.busy && _loadingState.success && _ceuTypes?.length"
  [class]="inputCssClass"
  [(ngModel)]="value"
  (change)="handleSelectChange($event)"
  [required]="required"
  [disabled]="disabled"
>
  <option value="0">--{{ 'common.select-one' | translate | titlecase }}--</option>
  <option *ngFor="let ceuType of _ceuTypes" [value]="ceuType.CECreditTypeID">
    {{ ceuType.CECreditType }}
  </option>
</select>
